// FollowerCard.js
import React, { useState } from 'react';
import { Card, CardBody, Row, Col } from 'reactstrap';

import { useNavigate } from "react-router-dom";

import { ChevronRight, ChevronDown } from 'lucide-react';
import ExperienceBar from './ExperienceBar';

import './FollowerCard.css';

const formatDateTime = (isoString) => {
  const date = new Date(isoString);
  const pad = (n) => (n < 10 ? '0' + n : n);
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

const FollowerCard = ({ follower, imageUrl }) => {

  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => setExpanded((prev) => !prev);

  return (
    <Card className="mb-2">
      <CardBody style={{
        padding: "10px 10px 10px 25px",
        border: "1px solid #bebebe",
        borderRadius: "5px"
      }}>
        <div className="d-flex flex-column justify-content-between align-items-start"
          style={{ cursor: 'pointer' }} onClick={toggleExpand}
        >
          <Row className="w-100">
            <Col xs="3" style={{ padding: "0" }}>
              <img
                src={imageUrl}
                alt={follower.displayName || 'Follower'}
                style={{ width: '55px', height: '55px', borderRadius: '50%' }}
                onClick={(e) => { e.stopPropagation(); navigate(`/myInfo/storeMenu/stores/${follower.storeId}`); }}
              />
            </Col>
            <Col xs="8" className="d-flex align-items-center"
              style={{ borderBottom: expanded ? "1px solid #bababa" : "none" }}
            >
              <div className="d-flex follower-card-displayname-div">
                <p className="mb-0 me-1 follower-card-displayname" style={{ fontSize: "20px" }}>
                  {follower.displayName || '未命名'}
                </p>
                <p className="mb-0 text-muted" style={{ fontSize: "8px" }}>{`(${follower.vipLevel})`}</p>
              </div>
            </Col>
            <Col xs="1" className="d-flex align-items-center justify-content-center" style={{ padding: '0' }}>
              {expanded ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
            </Col>
          </Row>
          
          {expanded && (
            <Row className="w-100" style={{ padding: "10px 0px" }}>
              <Col xs="3">
              </Col>
              <Col xs="9">
                {follower?.experience && (
                  <ExperienceBar 
                    levelData={follower.experience}
                  />
                )}
                <p className="mb-0 text-muted">
                  追蹤時間：{formatDateTime(follower.followedAt)}
                </p>
              </Col>
            </Row>
          )}
          
        </div>
      </CardBody>
    </Card>
  );
};

export default FollowerCard;



